import React from 'react'

export default ({disabled}) => {
    return (
        <option value='' disabled={disabled}>Select Country</option>
    )
}